var __jsx = React.createElement;
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useIsFocused, useOnUserSelected } from '@pelotoncycle/waffles';
import React from 'react';
import { shouldAnimateClass } from '@webtv/global-styles';
import { LargeSpinner } from '@webtv/shared-ui';
import { buttonFocused, buttonLoading } from './classNames';
import { useAnimateWithClick } from './useAnimateWithClick';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// Maps to button/medium/default in Zeplin
export var MediumButton = function MediumButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      handleClick = _ref.handleClick,
      isLoading = _ref.isLoading,
      tabIndex = _ref.tabIndex,
      focusRef = _ref.focusRef,
      ariaLabel = _ref.ariaLabel,
      dataTestId = _ref.dataTestId,
      ariaDescribedBy = _ref.ariaDescribedBy;
  var isFocused = useIsFocused();

  var _useAnimateWithClick = useAnimateWithClick(handleClick),
      shouldAnimate = _useAnimateWithClick.shouldAnimate,
      onAnimationEnd = _useAnimateWithClick.onAnimationEnd,
      onClickHandler = _useAnimateWithClick.onClickHandler;

  useOnUserSelected(!isLoading ? onClickHandler : function () {
    return null;
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledButton, {
      ref: focusRef,
      className: cx(className, isFocused && buttonFocused, isLoading && buttonLoading, shouldAnimate && shouldAnimateClass),
      onAnimationEnd: onAnimationEnd,
      tabIndex: tabIndex,
      role: 'button',
      "data-test-id": dataTestId,
      "aria-label": ariaLabel,
      "aria-describedby": ariaDescribedBy,
      children: isLoading ? /*#__PURE__*/_jsx(LargeSpinner, {}) : children
    })
  });
};
var StyledButton = /*#__PURE__*/styled("div")({
  name: "StyledButton",
  class: "s1a13rl8"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/buttons/MediumButton.linaria.module.css");